import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountssettingssimplifiinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4 18V9m16 0v9M8 9v9m4-9v9m4-9v9M12 6.275a.125.125 0 1 0 .126.125.127.127 0 0 0-.126-.125"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M21.5 9h-19V6.361L12 3l9.5 3.361zm-.5 9H3l-1 1v2h20v-2z",
		clipRule: "evenodd"
	})]
});
export default SvgAccountssettingssimplifiinline;
